import React, { createContext, useContext, useState } from "react";
import {isArrayNullOrEmpty} from "../../../Utilities/Types/arrayUtilities";

interface BatchApiResult {
    errors: string[];
    numberUpdated: number;
}

interface NotificationContextValue {
    errors: string[];
    infos: string[];
    setErrors: (val: string[]) => void;
    setInfos: (val: string[]) => void;
    setNotificationBatchApiResults: (results: BatchApiResult, successMessage: string, partialSuccessMessage: string) => void;
    setSuccesses: (val: string[]) => void;
    setWarnings: (val: string[]) => void;
    successes: string[];
    warnings: string[];
    [key: string]: unknown;
}

export const NotificationContext = createContext<NotificationContextValue>({} as NotificationContextValue);
export const useNotificationContext = (): NotificationContextValue => useContext(NotificationContext);

interface NotificationContextProviderProps {
    children: React.ReactNode;
}

export const NotificationContextProvider: React.FC<NotificationContextProviderProps> = ({
                                            children
                                        }) => {
const [errors, setErrors] = useState<string[]>([]);
const [infos, setInfos] = useState<string[]>([]);
const [successes, setSuccesses] = useState<string[]>([]);
const [warnings, setWarnings] = useState<string[]>([]);

    function setNotificationBatchApiResults(results: BatchApiResult, successMessage: string, partialSuccessMessage: string) {
        const warningMessage = results.errors.join(`<br/>`);

        if (isArrayNullOrEmpty(results.errors) && results.numberUpdated > 0)
            setSuccesses([successMessage]);
        else if (results.numberUpdated > 0 && results.errors.length > 0) {
            setSuccesses([partialSuccessMessage]);
            setWarnings([warningMessage]);
        } else{
            setWarnings([warningMessage]);
        }
    }


    return (
        <NotificationContext
            value={{
                errors,
                infos,
                setErrors,
                setInfos,
                setNotificationBatchApiResults,
                setSuccesses,
                setWarnings,
                successes,
                warnings
        }}>
            {children}
        </NotificationContext>
    );
};
